export default __webpack_public_path__ + "static/media/FakeJapanese06-Team.d3e45f7e.svg";